import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql';
import { fg } from '@confluence/feature-gating';
import { preloadReadTime } from '@confluence/read-time/entry-points/preloadReadTime';
import { preloadPageReactions } from '@confluence/reactions/entry-points/preloadPageReactions';
import { preloadClassificationContextForViewContent } from '@confluence/data-classification/entry-points/queries';
import { preloadContentAnalyticsViewers } from '@confluence/confluence-analytics/entry-points/preloadContentAnalyticsViewers';

import { ContentHeaderUnifiedQuery } from '../ContentHeaderUnifiedQuery.graphql';
import { DEFAULT_CONTRIBUTORS_FETCH_LIMIT } from '../defaultQueryVariables';

export type preloadEditorByLineDataProps = {
	isUnpublishedDraft?: boolean;
	spaceKey?: string;
	contentId: string;
};

export function preloadEditorByLineData({
	isUnpublishedDraft,
	spaceKey,
	contentId,
}: preloadEditorByLineDataProps) {
	const queries: Promise<any>[] = [];

	if (
		// eslint-disable-next-line confluence-feature-gating/no-preconditioning
		fg('cc_page_experiences_new_editor_byline') &&
		fg('cc_ssr_preload_header_data_for_edit_page')
	) {
		queries.push(
			query({
				/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
				query: ContentHeaderUnifiedQuery,
				variables: {
					contentId,
					spaceKey,
					versionOverride: null,
					embeddedContentRender: null,
					limit: DEFAULT_CONTRIBUTORS_FETCH_LIMIT,
					includeGeneratedBy: fg('cc-activation-user-generated-by-byline'),
					...(isUnpublishedDraft && { status: ['draft'] }),
				},
			}),
		);

		queries.push(
			preloadPageReactions({
				pageId: contentId,
				containerId: spaceKey,
			}),
		);

		// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
		if (process.env.REACT_SSR) {
			queries.push(
				preloadReadTime({ contentId, useCache: false, status: ['current', 'draft'] }),
				preloadContentAnalyticsViewers(contentId),
				preloadClassificationContextForViewContent(contentId),
			);
		}
	}

	return waitForAllReturnWhenError(queries);
}
